import Yup from 'utils/validation';
import { isCEPEmpty, isCNPJEmpty, isValidCNPJ, validDDDs } from 'utils/basicUtils';

export interface AccommodationSeturFormProps {
  selectedId?: string;
  item?: any;
}

export const states = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];

export const touristCorridors = [
  { label: "Arraial D'Ajuda", value: "Arraial D'Ajuda" },
  { label: 'Caraíva', value: 'Caraíva' },
  { label: 'Centro da Cidade', value: 'Centro da Cidade' },
  { label: 'Centro Histórico', value: 'Centro Histórico' },
  { label: 'Espelho', value: 'Espelho' },
  { label: 'Litoral Norte', value: 'Litoral Norte' },
  { label: 'Porto Seguro', value: 'Porto Seguro' },
  { label: 'Trancoso', value: 'Trancoso' },
  { label: 'Vale Verde', value: 'Vale Verde' },
];

export const accommodationSeturInitialValues = {
  id: '',
  businessRepresentative: '',
  businessOwner: [''],
  experiences: [],
  businessType: '',
  description: '',
  phone: '',
  document: '',
  facebookLink: '',
  googleMapsLink: '',
  instagramLink: '',
  status: '',
  tradeEmail: '',
  tradeName: '',
  youtubeLink: '',
  title: '',
  site: '',
  whatsapp: '',
  image: [],
  userId: 0,
  address_id: 0,
  createdAt: '',
  updatedAt: '',
  deletedAt: '',
  address: {
    id: 0,
    additionalData: '',
    city: '',
    neighborhood: '',
    number: '',
    state: '',
    street: '',
    zipCode: '',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
  },
  images: [],
  structures: [],
  user: '',
  touristCorridor: '',
  accommodation: {
    id: '',
    category: '',
    description: '',
    numberOfBeds: '',
    numberOfRooms: '',
  },
};

export const accommodationSeturValidationSchema = Yup.object().shape({
  id: Yup.number().notRequired(),
  touristCorridor: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O corredor turístico não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  businessType: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O tipo de negócio não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  description: Yup.string()
    .notRequired()
    .test('not-only-spaces', 'A descrição não pode conter apenas espaços', value => !value || value.trim().length > 0),
  document: Yup.string().notRequired(),
  googleMapsLink: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O link do Google Maps não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  tradeName: Yup.string()
    .notRequired()
    .test(
      'not-only-spaces',
      'O nome fantasia não pode conter apenas espaços',
      value => !value || value.trim().length > 0
    ),
  title: Yup.string()
    .notRequired()
    .test('not-only-spaces', 'O título não pode conter apenas espaços', value => !value || value.trim().length > 0),
  phone: Yup.string().strict(true).notRequired(),
  site: Yup.string().notRequired(),
  youtubeLink: Yup.string().notRequired(),
  instagramLink: Yup.string().notRequired(),
  facebookLink: Yup.string().notRequired(),
  whatsapp: Yup.string(),
  image: Yup.array().notRequired(),
  address: Yup.object().shape({
    id: Yup.number(),
    city: Yup.string()
      .strict(true)
      .notRequired()
      .test('not-only-spaces', 'A cidade não pode conter apenas espaços', value => !value || value.trim().length > 0),
    neighborhood: Yup.string()
      .strict(true)
      .notRequired()
      .test(
        'not-only-numbers',
        'O bairro não pode conter somente números',
        value => !value || /^(?!^\d+$)[\d\D]*$/.test(value)
      )
      .test('not-only-spaces', 'O bairro não pode conter apenas espaços', value => !value || value.trim().length > 0),
    number: Yup.string().strict(true).notRequired(),
    state: Yup.string()
      .strict(true)
      .notRequired()
      .test('not-only-spaces', 'O estado não pode conter apenas espaços', value => !value || value.trim().length > 0),
    street: Yup.string()
      .strict(true)
      .notRequired()
      .test(
        'not-only-numbers',
        'O campo endereço não pode ser apenas números',
        value => !value || /^(?!\d+$).*/.test(value)
      )
      .test('not-only-spaces', 'O endereço não pode conter apenas espaços', value => !value || value.trim().length > 0),
    zipCode: Yup.string().strict(true).notRequired(),
  }),
  images: Yup.array().notRequired(),
  accommodation: Yup.object().shape({
    id: Yup.string().matches(/^\d+$/, 'O ID deve conter apenas dígitos'),
    category: Yup.string()
      .strict(true)
      .notRequired()
      .test(
        'not-only-spaces',
        'A categoria não pode conter apenas espaços',
        value => !value || value.trim().length > 0
      ),
    description: Yup.string(),
    numberOfBeds: Yup.string()
      .strict(true)
      .notRequired()
      .test('is-digits', 'O número de leitos deve conter apenas dígitos', value => !value || /^\d+$/.test(value)),
    numberOfRooms: Yup.string()
      .strict(true)
      .notRequired()
      .test('is-digits', 'O número de quartos deve conter apenas dígitos', value => !value || /^\d+$/.test(value)),
  }),
});
